import TrendingPopover from "@/components/brand_portfolio/TrendingPopover.vue";
import TrendingValueWithPopover from "@/components/brand_portfolio/TrendingValueWithPopover.vue";
import LoadingElement from "@/components/shared/LoadingElement.vue";
export default {
  name: "BrandPortfolioTrendingCell",
  components: {
    TrendingPopover,
    TrendingValueWithPopover,
    LoadingElement
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    portfolio: {
      type: Object,
      default: {}
    },
    trendingType: {
      type: String,
      default: ""
    },
    isLastSellerInWorkspace: {
      type: Boolean,
      default: false
    }
  }
};